import { Component, Output, EventEmitter, Input } from "@angular/core";
import { CustomerService } from "app/@core/data/customer.service";
import { CustomerProfile } from "app/@core/models/customerProfile.entity";
import { TreeInputModel } from "app/@core/models/treeInputModel.entity";
import { DataService } from "app/@core/data/data.service";
import { TranslateJsonService } from "app/@core/data/translate-json.service";
import { WorkspaceService } from "app/@core/data/workspace.service";
import { Workspace, customerChildsPermissions } from "app/@core/models/workspace.data.entity";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'focus-customer-tree-input',
    styleUrls: ['./customer-tree-input.component.scss'],
    templateUrl: './customer-tree-input.component.html',
})
export class CustomerTreeInputComponent {
    @Output('selectedCustomersChild') selectedCustomersChild: EventEmitter<number[]> = new EventEmitter();
    @Output('selectedCustomerProfile') selectedCustomerProfile: EventEmitter<number[]> = new EventEmitter();
    
    @Input('onlyCustomerProfile') onlyCustomerProfile: boolean = false;
    @Input('activeCustomersOnly') activeCustomersOnly: boolean = false;

    loadedCustomersProfile: boolean = false;
    loadedCustomersChild: boolean = false;

    customerProfileList: TreeInputModel[] = [];
    customerChildList: TreeInputModel[] = [];

    customerProfileSelected: number[] = [];

    constructor(
        private customerService: CustomerService,
        private dataService: DataService,
        public translateJsonService: TranslateJsonService,
        private workspaceService: WorkspaceService,
        protected translateService: TranslateService,
    ){
        this.loadCustomersProfile();
    }

    loadCustomersProfile() {

        let kp: Workspace  = this.dataService.getWorkspace();
        let customersIds: number[] = []
        
        if(kp.dealerId === 1) {
            this.customerService.getCustomerProfiles().subscribe((allProfiles) => {
                this.customerProfileList = allProfiles.map(cusProf => ({
                    id: cusProf.id,
                    name: cusProf.name,
                    parentId: null
                }));
                this.loadedCustomersProfile = true;
            });
        } else {
            kp.userCustomerChildIds.forEach((customerChildsPermission : customerChildsPermissions ) => {
                if(!customersIds.includes(customerChildsPermission.customerProfile))                
                {
                    customersIds.push(customerChildsPermission.customerProfile)
                }
            });
            this.customerService.getCustomerProfilesByIds(customersIds).subscribe((result) => {            
                result.forEach((cusProf : CustomerProfile) => {
                    this.customerProfileList.push({id: cusProf.id, name: cusProf.name, parentId: null});
                })
                this.loadedCustomersProfile = true;
            });
        }
    }

    loadCustomersChild(customerProfileId: number[]) {
        this.loadedCustomersChild = false;
        this.customerProfileSelected = customerProfileId; 

        if(customerProfileId.length > 0){
            if (this.selectedCustomerProfile) {
                this.selectedCustomerProfile.emit(customerProfileId)
            }
            this.customerService.getParentsByCustomerProfileId(this.customerProfileSelected).subscribe((result) => {                                                                                              
            this.customerChildList = this.customerService.convertCustomerChildsToTreeInputModel(result.filter((c) => c.status == 1));
             this.loadedCustomersChild = true;
            })
        } 
    }        
}